import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';
import { PhasrBehavioralProfilesComponentController } from '../controller/PhasrBehavioralProfilesComponentController';
import { PhasrBehavioralProfilesComponentSchema } from '../types';
import { BehaviorProfilesOutput } from '../../phasrRestrictedProfilesSelector/types';

export class PhasrBehavioralProfilesComponent extends BaseWebComponentElement {
  public controller!: PhasrBehavioralProfilesComponentController;

  private gridData: PhasrBehavioralProfilesComponentSchema;
  private _collection = 'recommendations';

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: PhasrBehavioralProfilesComponentController,
    });
  }

  public setGridData(data: PhasrBehavioralProfilesComponentSchema): void {
    this.gridData = data;
  }

  public getGridData(): PhasrBehavioralProfilesComponentSchema {
    return this.gridData;
  }

  public get collection(): string {
    return this._collection;
  }

  public set collection(value: string) {
    this._collection = value;
  }

  public getSelectedOutput(): BehaviorProfilesOutput {
    return this.controller.getSelectedOutput();
  }

}
